export const API = process.env.REACT_APP_BACKEND; 
